import 'virtual:uno.css';
import { initConfig } from '@borealis/huck/client';
import ReactDOM from 'react-dom/client';
import { dynamicActivate } from '../activate-locale.js';
import { App } from './App.js';
import { getHuckConfig } from './utils/getHuckConfig.js';

const root = document.querySelector('#mobility-item-insertion-landing-page-root');
if (!root) {
  throw new Error('Root element #mobility-item-insertion-landing-page-root not found');
}

initConfig(root);

async function hydrate() {
  const config = getHuckConfig();
  await dynamicActivate(config.locale);

  if (root) {
    ReactDOM.hydrateRoot(root, <App />);
  }
}

hydrate();
